export const RouterRequestType = Object.freeze({
  NotRouterRequest: 0,
  Standard: 1,
  Modal: 2
});